export default __webpack_public_path__ + "static/media/delete_hover.e7ae7b04.svg";